import { ReactElement } from 'react';

import { Theme, Box, SxProps, Typography } from '@mui/material';

import { BackrsIcon, BackrsIcons } from './BackrsIcon';
import { appColors } from '../assets/appColors';

const ICON_SIZE = 24;

type IconRowProps = Readonly<{
  icon: BackrsIcons;
  text: string;
  onClick: () => void;
}>;

export const BackrsIconRow = ({ icon, text, onClick }: IconRowProps): ReactElement => {
  return (
    <Box sx={iconRowStyle} onClick={onClick}>
      <BackrsIcon
        name={icon}
        alt={text}
        color={appColors.color.blue1}
        width={ICON_SIZE}
        height={ICON_SIZE}
      />
      <Typography sx={typographyStyle}>{text}</Typography>
    </Box>
  );
};

const iconRowStyle: SxProps<Theme> = {
  cursor: 'pointer',
  gap: 2,
  flexDirection: 'row',
  display: 'flex',
};

const typographyStyle: SxProps<Theme> = {
  fontSize: '12pt',
  fontWeight: 'bold',
  color: appColors.color.blue1,
  '@media (max-width: 756px)': {
    fontSize: '12pt',
  },
};
